import React, { useState } from 'react';
import BoardControlsDrawer, { BoardColumn, BoardPrefs, loadBoardPrefs, isColumnVisible } from './BoardControlsDrawer';

/**
 * Self-contained "Board controls" gear button + drawer. Each page passes its
 * own toggleable `columns` and a unique `storageKey`; visibility persists per
 * page in localStorage. `onChange` reports the latest prefs so the page can
 * hide/show columns live.
 */
const BoardControlsButton: React.FC<{
  columns: BoardColumn[];
  storageKey: string;
  prefs: BoardPrefs;
  onChange: (prefs: BoardPrefs) => void;
}> = ({ columns, storageKey, prefs, onChange }) => {
  const [open, setOpen] = useState(false);
  const update = (p: BoardPrefs) => {
    localStorage.setItem(storageKey, JSON.stringify(p));
    onChange(p);
  };
  return (
    <div className="insights-board-controls-wrap">
      <button type="button" className="insights-board-controls-btn" onClick={() => setOpen(o => !o)}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
        Board controls
      </button>
      {open && (
        <BoardControlsDrawer
          columns={columns}
          prefs={prefs}
          onChange={update}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
};

export { loadBoardPrefs, isColumnVisible };
export type { BoardColumn, BoardPrefs };
export default BoardControlsButton;
